export const MESSAGE_CENTRE_ID = 'messageCentre';
